import * as Yup from 'yup';
import { ProjectPhase } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<ProjectPhase>().shape({
    name: Yup.string().nullable().required(),
  });
}
